import React, {useState} from 'react';

import {GenericNewElementPage} from 'app/components/general/GenericNewElementPage';
import {useCreatePolicy} from 'app/policies/api';
import {createNewProcedure} from 'app/procedures/actions';
import {createProcess} from 'app/process/actions';
import {getContentType} from 'app/utils/content-type';
import {useAsyncActions} from 'app/utils/redux';
import {capitalizeFirstLetter} from 'app/utils/strings';

import type {CreateNewDocProps} from 'app/general/types';
import type {
  DetailPolicySerializedType,
  ProcedureSerializedType,
  ProcessSerializedType,
} from 'sweet-types';

type AvailableDocType = 'procedure' | 'proceduregroup' | 'policy';

const availableDocTypes: Array<AvailableDocType> = [
  'procedure',
  'policy',
  'proceduregroup',
];

export function NewDocumentPage() {
  const [selectedDocType, selectDocType] =
    useState<AvailableDocType>('procedure');

  const [createPolicy] = useCreatePolicy();

  const createFunctions = useAsyncActions({
    // $FlowFixMe yes flow they will return promises
    procedure: createNewProcedure,
    // $FlowFixMe yes flow they will return promises
    proceduregroup: createProcess,
  });

  const create: {
    policy: (props: CreateNewDocProps) => Promise<DetailPolicySerializedType>;
    procedure: (props: CreateNewDocProps) => Promise<ProcedureSerializedType>;
    proceduregroup: (
      props: CreateNewDocProps
    ) => Promise<ProcessSerializedType>;
  } = {
    ...createFunctions,
    policy: (props: CreateNewDocProps) => createPolicy(props).unwrap(),
  };

  return (
    <GenericNewElementPage
      elementName={selectedDocType}
      createNewDocument={create[selectedDocType]}
      breadcrumbProps={{
        isDocsNamespace: true,
      }}
      advancedContent={
        <div className="my-2">
          {availableDocTypes.map((docType) => (
            <div className="form-check form-check-inline" key={docType}>
              <input
                className="form-check-input"
                type="radio"
                name="documentTypes"
                id={`${docType}-choice`}
                value={docType}
                checked={selectedDocType === docType}
                onChange={() => selectDocType(docType)}
              />
              <label
                className="form-check-label pr-2"
                htmlFor={`${docType}-choice`}
              >
                {capitalizeFirstLetter(getContentType(docType).name)}
              </label>
            </div>
          ))}
        </div>
      }
    />
  );
}
